var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 80,
    viewBox: "0 0 73 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.612 16.499v51.644c0 6.156-5.07 11.225-11.225 11.225H17.83c-6.167 0-11.236-5.07-11.236-11.225V16.5H2.598c-3.464 0-3.464-5.262 0-5.262h20.506V6.191c0-3.295 2.582-6.192 5.95-6.192h14.109c3.355 0 5.95 2.909 5.95 6.192v5.044h20.494c3.464 0 3.464 5.263 0 5.263h-3.995zm-37.246-5.262h15.473V6.191c0-.387-.23-.93-.676-.93h-14.11c-.458 0-.687.543-.687.93v5.044zm19.202 48.168c0 3.452-5.262 3.452-5.262 0V30.753c0-3.452 5.262-3.452 5.262 0v28.652zm-17.67 0c0 3.452-5.261 3.452-5.261 0V30.753c0-3.452 5.262-3.464 5.262 0v28.652zM60.35 16.5H11.867v51.644a5.967 5.967 0 005.962 5.963h36.558c3.283 0 5.962-2.68 5.962-5.963V16.5z",
    fill: "#D12421"
  })));
}
export default SvgBasket;